import {
  AmountPaid,
  BackToWebsite,
  LogoWrapper,
  MerChantAvatar,
  Wrapper,
  PaymentStatusWrapper,
  Header,
  StatusTitle,
} from './index.view';
import Icon from 'components/Icon';
import AnimationSuccess from './StatusSuccessAnimation';
import { useTranslation } from 'react-i18next';
import { currencyFormat } from 'utils/number';
import { useHistory, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { reqVerifyEmailPayment, IPaymentEmailDetails } from 'services/third-connect';
import routeUrlProvider, {
  ERROR_HAS_BEEN_PAID,
  LINK_EXPIRED,
  SOMETHING_WRONG,
} from 'constants/route-paths';
import FullPageSpinner from 'components/FullPageSpinner';

const PaymentStatus = () => {
  const { t } = useTranslation();
  const { token } = useParams<{ token: string }>();
  const { push } = useHistory();
  const [paymentDetails, setPaymentDetails] = useState<IPaymentEmailDetails>();

  useEffect(() => {
    if (!token) return;

    reqVerifyEmailPayment(token)
      .then((res) => {
        setPaymentDetails(res);
      })
      .catch((error) => {
        if (error?.statusCode === 400) {
          push(routeUrlProvider.getForLink(ERROR_HAS_BEEN_PAID));
        } else if (error?.statusCode === 401) {
          push(routeUrlProvider.getForLink(LINK_EXPIRED));
        } else {
          push(routeUrlProvider.getForLink(SOMETHING_WRONG));
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!paymentDetails || !token) {
    return <FullPageSpinner />;
  }

  return (
    <>
      <Header>
        <Icon name="logo" />
      </Header>

      <Wrapper>
        <PaymentStatusWrapper>
          <LogoWrapper>
            <MerChantAvatar src={paymentDetails?.logo_image || ''} />
            <AnimationSuccess />
          </LogoWrapper>
          <StatusTitle>{t('amountPaidToRoomTitle')}</StatusTitle>
          <AmountPaid>
            <>
              <strong>
                {t('amountPaidToRoomAmount', {
                  amount: currencyFormat(paymentDetails?.amount || 0),
                  tip: currencyFormat(paymentDetails?.tipAmount || 0),
                })}
              </strong>
              {t('amountPaidToRoomDesc')}
            </>
          </AmountPaid>

          <BackToWebsite
            onClick={() =>
              (window.location.href = paymentDetails?.redirect_link || 'https://www.fanz.io/')
            }
          >
            <span>{t('backToWebsite')}</span>
            <Icon name="arrowRight" />
          </BackToWebsite>
        </PaymentStatusWrapper>
      </Wrapper>
    </>
  );
};

export default PaymentStatus;
